// matches any affirmative key in case of changes
const coerceBool = (v) => {
	if (v === true || v === "true" || v === 1 || v === "1") return true;
	return false;
};

export const facilityAmenityMappings = [
	{
		canonicalKey: "twentyFourHourAccess",
		schemaName: "24-Hour Access",
		sourceKeys: ["24HourAccess", "twentyFourHourAccess", "twentyFourHours"],
		unitStrings: ["24 Hour Access", "24-Hour Access"]
	},
	{
		canonicalKey: "climateControlled",
		schemaName: "Climate Control",
		sourceKeys: ["climateControlled", "climateControl"],
		unitStrings: [
			"Climate Control",
			"Climate-Controlled",
			"Climate Controlled"
		]
	},
	{
		canonicalKey: "contactlessMoveIn",
		schemaName: "Contactless Move-In",
		sourceKeys: [
			"onlineMoveIn",
			"hasOnlineMoveins",
			"onlineMoveins",
			"onlineMoveIn"
		],
		unitStrings: [
			"Contactless Move-In",
			"Online Move-ins Available",
			"Online Move-ins",
			"Online Moveins"
		]
	},
	{
		canonicalKey: "driveUp",
		schemaName: "Drive-Up Access",
		sourceKeys: ["driveUp", "driveUpAccess", "drive_up"],
		unitStrings: ["Drive Up Access", "Drive-Up Access", "Drive-up access"]
	},
	{
		canonicalKey: "electronicGate",
		schemaName: "Electronic Gate Access",
		sourceKeys: ["egateAccess", "eGateAccess", "egate"],
		unitStrings: [
			"Electronic gate access",
			"Electronic Gate Access",
			"e-gate"
		]
	},
	{
		canonicalKey: "fencedAndLit",
		schemaName: "Fenced and Lit",
		sourceKeys: ["fencedLighted", "fencedAndLit"],
		unitStrings: ["Fenced and lit", "Fenced & Lit", "Fenced and Lit"]
	},
	{
		canonicalKey: "firstFloor",
		schemaName: "First Floor",
		sourceKeys: ["firstFloor", "1stFloor", "1st_floor"],
		unitStrings: ["1st Floor", "First Floor"]
	},
	{
		canonicalKey: "kiosk",
		schemaName: "Self-Service Kiosk",
		sourceKeys: ["kiosk", "selfServiceKiosk"],
		unitStrings: ["Self-service kiosk", "Self-Service Kiosk"]
	},
	{
		canonicalKey: "surveillance",
		schemaName: "Surveillance Cameras",
		sourceKeys: ["surveillance", "cameras"],
		unitStrings: ["Surveillance cameras", "Surveillance Cameras"]
	},
	{
		canonicalKey: "alarm",
		schemaName: "Alarm",
		sourceKeys: ["alarm"],
		unitStrings: ["Alarm", "Alarm in unit"]
	}
];

export function mapAmenitiesToFeature(
	facility = {},
	mappings = facilityAmenityMappings
) {
	// Use only facility-level amenities to determine feature applicability.
	// Clone to avoid mutating original facility.amenities (preserves snapshots & immutability)
	const facilityAmenitiesSource = facility.amenities || {};
	const facilityAmenities = { ...facilityAmenitiesSource };

	// Aggregate unique unit-level amenities safely and efficiently
	const amenitiesSet = new Set();

	if (Array.isArray(facility.units)) {
		facility.units.forEach((unit) => {
			const list = unit?.amenitiesList;
			if (typeof list === "string" && list.length) {
				list.split(",").forEach((amenity) => {
					const trimmedAmenity = amenity.trim();
					if (trimmedAmenity) {
						amenitiesSet.add(trimmedAmenity);
					}
				});
			}
		});
	}

	amenitiesSet.forEach((amenity) => {
		if (!Object.prototype.hasOwnProperty.call(facilityAmenities, amenity)) {
			facilityAmenities[amenity] = true;
		}
	});

	// Check both facility and facility.amenities for keys
	const checkFacilityKey = (key) => {
		if (facility?.[key]) {
			return coerceBool(facility[key]);
		}

		if (facilityAmenities?.[key]) {
			return coerceBool(facilityAmenities[key]);
		}

		return false;
	};

	// produces amenityFeature schema for withSelfStorageSchema decorator
	// We can abstract this out if we need it elsewhere
	const res = mappings.map((m) => {
		let applies = false;

		const sourceKeys = m.sourceKeys || [];
		for (let index = 0; index < sourceKeys.length; index += 1) {
			const key = sourceKeys[index];
			if (checkFacilityKey(key)) {
				applies = true;
				break;
			}
		}

		// iterate over unitStrings
		const unitStrings = m.unitStrings || [];
		for (let index = 0; index < unitStrings.length; index += 1) {
			const key = unitStrings[index];
			if (checkFacilityKey(key)) {
				applies = true;
				break;
			}
		}

		return {
			"@type": "LocationFeatureSpecification",
			name: m.schemaName,
			value: !!applies
		};
	});

	return res;
}
